import { NgFor } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import {
  AbstractDialogResultData,
  AbstractFormDialog,
  AbstractFormDialogData,
  FormDialogComponent,
} from '@next/core-lib/dialog';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';

export interface FeedAdviceCountryDialogInputData extends AbstractFormDialogData {
  countries: string[];
}

export interface FeedAdviceCountryDialogResultData {
  country: string;
}
@Component({
  selector: 'app-feed-advice-country-dialog',
  templateUrl: './feed-advice-country-dialog.component.html',
  styleUrls: ['./feed-advice-country-dialog.component.scss'],
  imports: [
    FormDialogComponent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    NgFor,
    MatOption,
    TranslatePipe,
  ],
})
export class FeedAdviceCountryDialogComponent extends AbstractFormDialog<FeedAdviceCountryDialogResultData> {
  formGroup: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FeedAdviceCountryDialogInputData,
    protected mdDialogRef: MatDialogRef<
      FeedAdviceCountryDialogComponent,
      AbstractDialogResultData<FeedAdviceCountryDialogResultData>
    >,
    private readonly locale: LocaleService,
  ) {
    super();

    this.data.title = this.locale.translate('select-feed-advice-country.title');

    this.formGroup = new FormGroup({
      country: new FormControl(null, [Validators.required]),
    });
  }

  getFeedadviceCountryLabel(country: string) {
    const label = this.locale.translate('select-feed-advice-country.' + country);
    return label;
  }

  save(): void {
    this.confirm({ country: this.formGroup.value.country });
  }
}
